import React, { FC } from 'react';

import { Nullable } from '@/types';
import formatCountryCode from '@/utils/formatter/formatCountryCode';

export const Country: FC<{ countryCode?: Nullable<string> }> = ({
  countryCode,
}) => <span className="tabular-nums">{formatCountryCode(countryCode)}</span>;
